<template>
  <div>
    <div class="sidebar-wrapper" @click="isOpen=false" v-if="isOpen"></div>
    <transition name="slide">
      <div id="sidebar-mobile" v-if="isOpen">
        <div class="toggle-filters" v-on:click="isOpen=false">
          Close
          <i class="far fa-times-circle"></i>
        </div>
        <Filters></Filters>
      </div>
    </transition>
  </div>
</template>

<script>
import Filters from "@/components/Filters.vue";

export default {
  name: "sidebar-mobile",
  data: function() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleSidebar() {
      this.isOpen = !this.isOpen;
    }
  },
  components: {
    Filters
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.sidebar-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.1;
  z-index: 103;
}

#sidebar-mobile {
  z-index: 104;
  overflow-y: scroll;
  overflow-x: hidden;
  background: $light;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 25%;
  box-shadow: 8px 10px 8px -8px #888;
  padding: $standard-padding;
}

.toggle-filters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.2em;
  color: darken($primary-dark, 30%);
  i {
    margin-left: 0.5em;
  }
}

.slide-enter-active {
  animation: slide-in-right 0.2s cubic-bezier(1, 0.5, 0.8, 1) both;
}

.slide-leave-active {
  animation: slide-in-right 0.2s cubic-bezier(1, 0.5, 0.8, 1) both reverse;
}
</style>